import i18n from '../i18n';
import { fetchContentMap } from './api';
import { supabase } from './supabaseClient';

// Curated, faktycznie wyświetlane teksty stron — pogrupowane dla panelu.
export const CONTENT_GROUPS = [
  {
    section: 'Nawigacja (menu)',
    items: [
      { key: 'nav.home', label: 'Strona główna' },
      { key: 'nav.ourDogs', label: 'Nasze psy' },
      { key: 'nav.litters', label: 'Mioty' },
      { key: 'nav.shows', label: 'Wystawy' },
      { key: 'nav.aboutBreed', label: 'O rasie' },
      { key: 'nav.gallery', label: 'Galeria' },
      { key: 'nav.contact', label: 'Kontakt' },
    ],
  },
  {
    section: 'Strona główna',
    items: [
      { key: 'home.about.title', label: 'Tytuł powitania' },
      { key: 'home.about.p1', label: 'Akapit 1', multiline: true },
      { key: 'home.about.p2', label: 'Akapit 2', multiline: true },
      { key: 'home.about.p3', label: 'Akapit 3', multiline: true },
    ],
  },
  {
    section: 'Nasze psy',
    items: [
      { key: 'ourDogs.title', label: 'Tytuł' },
      { key: 'ourDogs.subtitle', label: 'Podtytuł', multiline: true },
      { key: 'ourDogs.females_section_title', label: 'Nagłówek: Suki' },
      { key: 'ourDogs.males_section_title', label: 'Nagłówek: Samce' },
      { key: 'ourDogs.youth_section_title', label: 'Nagłówek: Na zawsze z nami' },
    ],
  },
  {
    section: 'Mioty',
    items: [
      { key: 'litters.title', label: 'Tytuł' },
      { key: 'litters.subtitle', label: 'Podtytuł', multiline: true },
    ],
  },
  {
    section: 'Wystawy',
    items: [
      { key: 'shows.title', label: 'Tytuł' },
      { key: 'shows.subtitle', label: 'Podtytuł', multiline: true },
    ],
  },
  {
    section: 'O rasie',
    items: [
      { key: 'aboutBreed.title', label: 'Tytuł' },
      { key: 'aboutBreed.subtitle', label: 'Podtytuł', multiline: true },
      { key: 'aboutBreed.history.title', label: 'Historia — nagłówek' },
      { key: 'aboutBreed.history.p1', label: 'Historia — treść', multiline: true },
      { key: 'aboutBreed.character.title', label: 'Charakter — nagłówek' },
      { key: 'aboutBreed.character.p1', label: 'Charakter — akapit 1', multiline: true },
      { key: 'aboutBreed.character.p2', label: 'Charakter — akapit 2', multiline: true },
    ],
  },
  {
    section: 'Galeria',
    items: [
      { key: 'gallery.title', label: 'Tytuł' },
      { key: 'gallery.subtitle', label: 'Podtytuł', multiline: true },
    ],
  },
  {
    section: 'Kontakt',
    items: [
      { key: 'contact.title', label: 'Tytuł' },
      { key: 'contact.subtitle', label: 'Podtytuł', multiline: true },
      { key: 'contact.details.title', label: 'Dane — nagłówek' },
      { key: 'contact.details.name', label: 'Dane — imię i nazwisko' },
      { key: 'contact.details.location', label: 'Dane — lokalizacja' },
    ],
  },
];

export const ALL_CONTENT_ITEMS = CONTENT_GROUPS.flatMap((g) =>
  g.items.map((it) => ({ ...it, section: g.section }))
);

function setNested(obj, dotKey, value) {
  const parts = dotKey.split('.');
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    cur[parts[i]] = cur[parts[i]] || {};
    cur = cur[parts[i]];
  }
  cur[parts[parts.length - 1]] = value;
}

// Domyślna (wbudowana) wartość tekstu z i18n dla danego klucza/języka.
export function defaultText(key, lng) {
  return i18n.getResource(lng, 'translation', key);
}

// Pobiera nadpisania z bazy i wstrzykuje je do i18n (komponenty odświeżą się dzięki bindI18n 'added').
export async function applyContentOverrides() {
  try {
    const map = await fetchContentMap();
    const plBundle = {};
    const enBundle = {};
    for (const [key, val] of Object.entries(map)) {
      if (key.startsWith('settings.')) continue; // ustawienia strony, nie teksty
      if (val.pl) setNested(plBundle, key, val.pl);
      if (val.en) setNested(enBundle, key, val.en);
    }
    // Zawsze emituj, aby komponenty odświeżyły się także po cofnięciu nadpisania (powrót do domyślnych po reloadzie).
    if (Object.keys(plBundle).length) i18n.addResourceBundle('pl', 'translation', plBundle, true, true);
    if (Object.keys(enBundle).length) i18n.addResourceBundle('en', 'translation', enBundle, true, true);
    i18n.emit('languageChanged', i18n.language);
  } catch {
    // brak połączenia / błąd — zostają teksty domyślne
  }
}

// Utrzymuje teksty aktualne „na żywo": Realtime + odświeżenie po powrocie do karty.
export function subscribeContentLive() {
  const onVisible = () => { if (document.visibilityState === 'visible') applyContentOverrides(); };
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', onVisible);
  if (supabase) {
    supabase
      .channel('rt-site_content')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'site_content' }, () => applyContentOverrides())
      .subscribe();
  }
}
